'use client'

import { useId } from 'react'

type Props = {
  className?: string
  width?: number
  height?: number
}

export const QuotesIcon = ({ className, width = 39, height = 25 }: Props) => {
  const id = useId()

  return (
    <span className={className} style={{ lineHeight: 1, display: 'inline-block' }}>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 39 25" fill="none">
        <path
          d="M37.8506 0.458496L38.2495 1.64702C29.4729 5.41068 25.0846 9.96669 23.4889 13.5323L23.8878 13.7304C27.4782 13.2351 29.8719 15.7112 29.8719 18.8806C29.8719 22.05 27.2788 24.6252 23.9875 24.6252C20.7961 24.6252 18.1032 21.7529 18.1032 18.0883C18.1032 11.5514 24.2867 5.70781 37.8506 0.458496ZM20.4969 0.458496L20.8958 1.64702C12.1192 5.41068 7.73089 9.96669 6.13515 13.5323L6.53409 13.7304C10.1245 13.2351 12.5181 15.7112 12.5181 18.8806C12.5181 22.05 9.92504 24.6252 6.63382 24.6252C3.44233 24.6252 0.749512 21.7529 0.749512 18.0883C0.749512 11.5514 6.93302 5.70781 20.4969 0.458496Z"
          fill={`url(#quotes-gradient-${id})`}
        />
        <defs>
          <linearGradient
            id={`quotes-gradient-${id}`}
            x1="19.4995"
            y1="0.458496"
            x2="19.4995"
            y2="45.771"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#B7ECDA" />
            <stop offset="1" stopColor="#40AD87" />
          </linearGradient>
        </defs>
      </svg>
    </span>
  )
}
